const customVideoControls = () => {
    const videosWithNoControls = document.querySelectorAll('.wp-block-video:not(:has(video[controls]))');
    if (videosWithNoControls.length === 0) return;
    
    const customEnableControls = videoBlock => {
        videoBlock.classList.add('custom-controls');
        const video = videoBlock.querySelector('video');
        videoBlock.addEventListener('click', () => {
            video.controls = true;
            video.play();
            videoBlock.classList.remove('custom-controls');
        })
    }

    videosWithNoControls.forEach(customEnableControls);
}

export default customVideoControls